import styled from "styled-components";

export const Container = styled.div`
  padding: ${(props) => props.theme.padding.mobile} 20px;

  h1 {
    color: #2d2d2d;
    text-align: center;
    font-family: Mulish;
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 30px;
    letter-spacing: 0.6px;
    margin-bottom: 48px;
  }

  @media (min-width: 640px) {
    padding: ${(props) => props.theme.padding.primary} 20px;
  }
`;

export const Form = styled.form`
  width: 100%;
  max-width: 700px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 32px 16px;
  margin: 0 auto;

  > div:first-child {
    display: flex;
    flex-direction: column;
    gap: 32px 16px;
    min-width: 100%;

    div#wrapperInputSwitch {
      display: flex;
      gap: 64px;
      width: fit-content;
      margin: auto;
      grid-column: span 2;
    }

    @media (min-width: 640px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
  }

  > div {
    width: 100%;
    max-width: 340px;
  }

  div#wrapperButton {
    width: 100%;
    max-width: 700px;
  }

  div#wrappre-horarios {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 32px 16px;
    min-width: 100%;

    > div#alertHorario {
      grid-column: span 2;
      margin: auto;

      h3 {
        color: #2d2d2d;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        padding: 0 32px;
        border-radius: 2px;
        background: #f7f7f7;
      }
    }

    > div#alertAtendimento {
      grid-column: span 2;
      margin: auto;

      h4 {
        color: #2d2d2d;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        padding: 8px 32px;
        border-radius: 2px;
        background: #e8e8e8;

        > span {
          color: #ed0000;
        }
      }
    }
  }

  button {
    margin: auto;
  }
`;
